import { AuthTokenExpiredException } from '@pkg/basic'
import { apiClient } from '../../constants'

export const resetPortfolioLastUsedAt = async (params: {
  getToken: () => Promise<string | null>
  id: string
}) => {
  const { getToken, id } = params

  const token = await getToken()
  if (token === null) {
    throw new AuthTokenExpiredException()
  }
  const response = await apiClient.v1.portfolio[':id'].use.$post(
    {
      json: {
        timestamp: 0,
      },
      param: { id },
    },
    {
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/json',
      },
    },
  )
  if (!response.ok) {
    throw new Error(
      `Failed to update lastUsed: ${response.status} ${response.statusText}`,
    )
  }
}
